import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import {AuthService} from "../../../shared/services/auth.service";
import { properties } from 'src/environments/properties';
import { filter } from 'rxjs/operators';
import { GameService } from 'src/app/shared/services/game/game.service';

@Component({
  selector: 'app-manage-games',
  templateUrl: './manage-games.component.html',
  styleUrls: ['./manage-games.component.scss']
})
export class ManageGamesComponent implements OnInit {
  
  public PlayEarn = properties.PlayEarn;
  public PlayEarnSub = properties.PlayEarnSub;
  public noGamesBonus = properties.noGamesBonus;
  public continueExploring = properties.continueExploring;
  public gamesExist = true;
  public bonusPathExist = true;
  public templateLoaded = false;
  gameGrid = false;
  gameDetails = false;
  gamePrizeDetails = false;
  gameOverPage = false;
  selectedGame : string = '';
  pagePath: string = '';
  currentPath: string ='';
  currentParams: any ='';
  private dynamicTemplate: any;
  public userInfo: any;
  public isTokenValid: boolean;

  // game-Details page
  public singleCard = false;
  @ViewChild("prizeGrid", {static: true})
  prizeGrid: ElementRef;
  @ViewChild("myPrizeList", {static: true})
  myPrizeList: ElementRef;
  @ViewChild("activity", {static: true})
  activity: ElementRef;

  constructor(private authService: AuthService, public gameService: GameService, private router: Router, public route: ActivatedRoute) { }

  ngOnInit(): void {
    this.getUserInfo();
    if (window && window['AB'] && window['AB']['DATALAYER'] && window['AB']['DATALAYER'].initAngularSPA) {
      window['AB']['DATALAYER'].initAngularSPA();
    }
    this.gameService.manageGamesInfoObserable.subscribe(data => {
      this.gamesExist = data.gamesExist;
    });
    this.gameService.bonusPathObserable.subscribe(data => {
      this.bonusPathExist = data.bonusPathExist;
    });
  }

  pagePathMap() {
    const activeRoute = this.route.snapshot;
    this.currentPath = activeRoute.url.join('/');
    this.currentParams = activeRoute.params;
    this.route.paramMap.subscribe(params => {
      const fullId = params.get('id');
      // when we are in game-details page and session expires after login - it will redirect to game-details page with game-details/selectedGame.html format
      // game-details/selectedGame.html - spliting the .html to pass the selectedGame (id) to game-details page
      if (fullId) {
        const [id, extension] = fullId.split('.');
        this.selectedGame = id;
      }
    });
    if(this.currentPath.includes('game-grid')) {
      this.pagePath = 'gameGrid';
    } else if (this.currentPath.includes('game-details')) {
      this.pagePath = 'gameDetails';
    } else if (this.currentPath.includes('game-over')) {
      this.pagePath = 'gameOver';
    } else if (this.currentPath.includes('prize-details')) {
      this.pagePath = 'gamePrizeDetails';
    }

  }

  getUserInfo() {
    this.authService.populateSessionData$.subscribe((userInfo) => {
      if (userInfo) {
        this.userInfo = userInfo;
        this.userInfo.j4uStoreId = userInfo.j4uStoreId || userInfo.storeId;
        if (userInfo.isTokenValid) {
          this.isTokenValid = true;
          this.pagePathMap();
          this.loadDynamicTemplate(this.pagePath);
        } else {
          this.isTokenValid = false;
          this.authService.redirectToSSO(this.userInfo);
        }
      }
    });
  }

  loadDynamicTemplate(templateName: string) {
    //Loading template based page logic
    switch (templateName) {
      case 'gameGrid':
        this.singleCard = false;
        this.gameGrid = true;
        this.gamesExist = true;
        break;
      case 'gameDetails':
        this.singleCard = true;
        this.gameDetails = true;
        break;
      case 'gamePrizeDetails':
        this.singleCard = true;
        this.gamePrizeDetails = true;
        break;
      case 'gameOver':
        this.gameOverPage = true;
        break;
      default:
        this.gameGrid = true;
        this.singleCard = false;
    }
    this.templateLoaded = true;
  }

}
